
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SchoolIcon from "@mui/icons-material/School";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import GroupsIcon from "@mui/icons-material/Groups";

const FeaturesSection = () => {
  const features = [
    {
      id: 1,
      title: "Expert Quran Tutors",
      description:
        "All classes are conducted by qualified Islamic instructors with deep Quranic knowledge.",
      icon: <SchoolIcon fontSize="medium" />,
    },
    {
      id: 2,
      title: "We Value Our Students",
      description:
        "Learn proper Quran recitation with Tajweed rules in a structured way.",
      icon: <MenuBookIcon fontSize="medium" />,
    },
    {
      id: 3,
      title: "Female & Male Teachers Available ",
      description:
        "Live one-to-one and group sessions with personalized attention.",
      icon: <AutoStoriesIcon fontSize="medium" />,
    },
    {
      id: 4,
      title: "Flexible Timings",
      description:
        "Join a supportive Islamic learning community across the globe.",
      icon: <GroupsIcon fontSize="medium" />,
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our Islamic Institute
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Learn Quran and Islamic studies with expert guidance and a
            spiritually enriching environment
          </p>
        </div>

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="
                h-[360px]
                w-full
                rounded-[40px]
                border border-black
                bg-gradient-to-br from-white via-pink-50 to-purple-50
                px-8 py-10
                flex flex-col items-center text-center
                transition-all duration-300
                hover:border-green-300
                hover:shadow-lg
              "
            >
              {/* Icon Circle */}
              <div className="w-16 h-16 rounded-full bg-yellow-500  border border-green-200 flex items-center justify-center text-green-700 mb-6">
                {feature.icon}
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
